module.exports = __webpack_public_path__ + "00903f8e2bc57850b09cadbb0f9bab7c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/a2p-3.png
// module id = 839
// module chunks = 0